$(document).ready(function() {
    $('.collection-course-slider').slick({
        infinite: true,
        slidesToShow: 4,
        variableWidth: true,
        centerMode: false,
        vertical: false,
        swipeToSlide: true,
        initialSlide: 0,
        centerPadding: '40px',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 768,
              settings: {
                infinite: false,
                slidesToShow: 1
              }
            }
        ]
    });
});
